import {faLibrary, FontAwesomeIcon as fai} from '@literacyplanet/client_core';

import {faImage} from '@fortawesome/pro-solid-svg-icons/faImage';
import {faImage as faImageRegular} from '@fortawesome/pro-regular-svg-icons/faImage';
import {faLeftToBracket} from '@fortawesome/pro-solid-svg-icons/faLeftToBracket';
import {faRightFromBracket} from '@fortawesome/pro-solid-svg-icons/faRightFromBracket';
import {faPercent} from '@fortawesome/pro-solid-svg-icons/faPercent';
import {faTrophy} from '@fortawesome/pro-solid-svg-icons/faTrophy';
import {faXmark} from '@fortawesome/pro-solid-svg-icons/faXmark';
import {faXmark as faXmarkRegular} from '@fortawesome/pro-regular-svg-icons/faXmark';

faLibrary.add([
  faImage,
  faImageRegular,
  faLeftToBracket,
  faRightFromBracket,
  faPercent,
  faTrophy,
  faXmark,
  faXmarkRegular
]);
export const FontAwesomeIcon = fai;
